// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView } from "@insite/client-framework/Store/Data/DataState";
import { GetShipmentsApiParameter } from "@store/Framework/Services/ShipmentService";
import { createContext } from "react";

export function getShipmentsDataView(state: ApplicationState, getShipmentsParameter: GetShipmentsApiParameter) {
    return getDataView(state.greif.data.shipments, getShipmentsParameter);
}

export const ShipmentsDataViewContext = createContext<ReturnType<typeof getShipmentsDataView>>({
    value: undefined,
    isLoading: false,
});
